/**
 * 默认左侧菜单配置
 */
export const leftMenuConfig = [
  {
    name: '推广方式',
    selected: true,
    icon: 'icon-style',
    children: [
      {
        name: '商品推广',
        selected: true,
        href: '/pcChoice/index.html'
      },
      {
        name: '店铺推广',
        selected: false,
        href: '/union/member/promotion/store/list.htm'
      },
      {
        name: '定制推广',
        selected: false,
        href: '/union/member/promotion/custom/link.htm'
      },
      {
        name: '活动推广',
        selected: false,
        href: '/union/member/promotion/activity/list.htm'
      },
      {
        name: '频道推广',
        selected: false,
        href: '/union/member/promotion/channel/list.htm'
      },
      {
        name: '搜索推广',
        selected: false,
        href: '/union/member/promotion/search/link.htm'
      },
      {
        name: '组件推广',
        selected: false,
        href: '/union/member/promotion/component/link.htm'
      },
    ]
  },
  {
    name: '效果报表',
    selected: false,
    icon: 'icon-sheet',
    children: [
      {
        name: '效果概况',
        selected: false,
        href: '/union/member/promotion/effectReport/list.htm'
      },
      {
        name: 'CPS明细报表',
        selected: false,
        href: '/union/member/promotion/cpsOrderReport/list.htm'
      },
      {
        name: 'CPA明细报表',
        selected: false,
        href: '/union/member/promotion/cpaReport/list.htm'
      },
      {
        name: '推广位报表',
        selected: false,
        href: '/union/member/myPromotion/report/promotionPosition/list.htm'
      },
      {
        name: '锁粉明细报表',
        selected: false,
        href: '/union/member/promotion/report/lockFans/list.htm'
      },
    ]
  },
  {
    name: '推广管理',
    selected: false,
    icon: 'icon-manage',
    children: [
      {
        name: '网站管理',
        selected: false,
        href: '/union/member/myPromotion/mediaSite/toListPage.htm'
      },
      {
        name: '社交媒体管理',
        selected: false,
        href: '/union/member/myPromotion/socialMedia/list.htm'
      },
      {
        name: '推广位管理',
        selected: false,
        href: '/union/member/myPromotion/promotionPosition/list.htm'
      },
      {
        name: '推广计划管理',
        selected: false,
        href: '/union/member/myPromotion/plan/list.htm'
      },
    ]
  },
  {
    name: '招商推广',
    selected: false,
    icon: 'icon-yqt',
    children: [
      {
        name: '招商活动推广',
        selected: false,
        href: '/union/member/promotion/merchant/activityList.htm'
      },
      {
        name: '招商活动管理',
        selected: false,
        href: '/union/member/promotion/merchant/activityMgrList.htm'
      },
    ]
  },
  {
    name: '团长招商活动',
    selected: false,
    icon: 'icon-yqt',
    children: [
      {
        name: '招商活动推广',
        selected: false,
        href: '/unionNew/pages/yqt/initiate-activities.html'
      },
      {
        name: '效果概况',
        selected: false,
        href: '/unionNew/pages/colonelBusiness/effectState.html'
      },
      {
        name: '订单明细',
        selected: false,
        href: '/unionNew/pages/colonelBusiness/orderDetails.html'
      },
    ]
  },
]
/**
 * 开发平台左侧菜单配置
 */
export const leftMenuConfigOpen = [
  {
    name: '开放平台',
    selected: true,
    icon: 'icon-manage',
    children: [
      {
        name: '开放平台',
        selected: true,
        href: '/openPlatform/index.html'
      }
    ]
  }
]